import {
  laravelGet,
  laravelPost,
  laravelPut,
  laravelDelete,
} from '../utils/laravelClient';

export const getHookahTypes = async () =>
  laravelGet('/hookah-types', { auth: 'none' });

export const getHookahTypesAdmin = async () =>
  laravelGet('/hookah-types-admin', { auth: 'admin' });

export const getHookahType = async (id) =>
  laravelGet(`/hookah-types/${id}`, { auth: 'none' });

export const createHookahType = async (data) =>
  laravelPost('/hookah-types', data, { auth: 'admin' });

export const updateHookahType = async (id, data) =>
  laravelPut(`/hookah-types/${id}`, data, { auth: 'admin' });

export const deleteHookahType = async (id) =>
  laravelDelete(`/hookah-types/${id}`, { auth: 'admin' });
